export default __webpack_public_path__ + "static/media/Manual_Usuario.5aa8fd1f.pdf";